<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    @ok="handleOk"
    :cancelButtonProps="{ class:{'jee-hidden': true} }"
    @cancel="handleCancel"
    cancelText="">

    <div class="sort-table">
      <div class="sort-table-top">
        <div class="sort-table-left">
          <div class="title">表头固定区域</div>
            <draggable v-model="leftList"
                       @add="startLeft"
                       @end="endLeft"
                       group="article"
                       class="sort-table-content content">
                <div class="dra-item" v-for="item in leftList">{{item.title || item.titleName}}</div>
            </draggable>

        </div>
        <div class="sort-table-center">
          <div class="title">滑动区域</div>
          <draggable v-model="centerList"
                     @start="startLeft"
                     @end="endLeft"
                     group="article"
                     class="sort-table-content content">
            <div class="dra-item" v-for="item in centerList">{{item.title || item.titleName}}</div>
          </draggable>
        </div>
        <!--<div class="sort-table-right">-->
          <!--<div class="title">尾部固定区域</div>-->
          <!--<draggable v-model="rightList"-->
                     <!--@start="startLeft"-->
                     <!--@end="endLeft"-->
                     <!--group="article"-->
                     <!--class="sort-table-content content">-->
            <!--<div class="dra-item" v-for="item in rightList">{{item.title || item.titleName}}</div>-->
          <!--</draggable>-->
        <!--</div>-->
      </div>
      <div class="sort-table-bottom">
        <div class="sort-table-des">
          请将下方需要的字段拖拽至上方对应的区域内
        </div>
        <div>
          <a  @click="huanyuan">还原默认</a>
        </div>
      </div>

      <draggable :list="allList"
                 group="article"
                 @end="endLeft"
                 class="sort-table-content">
        <div v-for="element in allList" :key="element.dataIndex"
             :class="{undraggable : element.flag}"
             class="dra-item">
          {{element.title || element.titleName}}
        </div>
      </draggable>
    </div>
  </j-modal>

</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import draggable from 'vuedraggable'
  export default {
    name: 'SortTable',
    components: {
      draggable
    },
    props: {

    },data(){
      return {
        visible:false,
        title:'列表排序',
        width:1446,
        disabled:false,
        leftList:[

        ],
        centerList:[],
        rightList:[],
        allList:[

        ],
        menuTab:'',
        mrColumns:[],
        defaultColumns:[]
      }
    },create(){

    },methods:{
      show(columns,defaultColumns,menuTab,mrColumns){
        this.menuTab = menuTab;
        this.clear();
        this.visible = true;
        this.mrColumns = mrColumns;
        this.defaultColumns = defaultColumns;
        this.formatList(columns);
      },formatList(columns){
        let map = {}
        if(columns){
          for(let a in columns){
            map[columns[a].dataIndex] = columns[a];
          }
        }
        if(this.defaultColumns){
          for(let b in this.defaultColumns){
            let c = this.defaultColumns[b];
            if(!map[c.dataIndex]){
              this.allList.push(c);
            }else{
              let d = map[c.dataIndex];
              if(d.position=='left' || d.fixed=='left'){
                this.leftList.push(c);
              }else if(d.position=='right' || d.fixed=='right'){
                //this.rightList.push(c);
              }else{
                this.centerList.push(c);
              }
            }

          }
        }
      },clear(){
        this.leftList = [];
        this.centerList = [];
        this.rightList = [];
        this.allList = [];
      },
      handleOk(){
        if(this.leftList.length==0 &&
          this.centerList.length==0 &&
          this.rightList.length==0) {
          this.$message.warning("至少拖动一个字段到表格区域");
          return;
        }
        let param = {
          menuTab:this.menuTab,
          leftList:this.getStr(this.leftList),
          centerList:this.getStr(this.centerList),
          rightList:this.getStr(this.rightList),
        }
        httpAction("/dm/dmTableSort/saveOrUpdate",param,"PUT").then(res=>{
          if(res.success){
            this.$emit("ok");
            this.handleCancel();
          }
        });
      },getStr(list){
        let str = ''
        if(list && list.length>0){
          for(let a in list){
            str += ","+list[a].dataIndex;
          }
          str = str.substring(1);
        }
        return str;
      },handleCancel(){
        this.visible = false
      },huanyuan () {
        this.clear();
        this.formatList(this.mrColumns);
      },startLeft(){

      },endLeft(){

      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';

  /deep/ .ant-btn{
    width: 160px;
  }
  .sort-table{
    margin: 24px 0;
    .sort-table-top{
      display: flex;
      justify-content: space-between;
      .title{
        color: rgba(125, 133, 146, 1);
        text-align: center;
        margin-bottom: 24px;
      }
      .sort-table-left .content{
        background: #fae7e9;
      }
      .sort-table-center .content{
        background: #e4eefc;
      }
      .sort-table-right .content{
        background: #eae9f7;
      }
      .content{
        padding: 12px 24px;
        width: 620px;
        min-height: 72px;
        border-radius: 6px;
      }
    }

    .sort-table-bottom{
      padding: 24px 0;
      margin-top: 24px;
      border-bottom: 1px solid rgba(228, 230, 232, 1);
      display: flex;
      justify-content: space-between;
    }

    .sort-table-content{
      padding: 24px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 24px;
      .dra-item{
        height: 48px;
        padding: 0 18px;
        border-radius: 6px;
        border: 1px solid #D8E0F0;
        color: rgba(10, 22, 41, 1);
        text-align: center;
        line-height: 48px;
        cursor: pointer;
        background: #fff;
      }
    }
  }


  .chooseItem{
    /*background: #1890FF !important;*/
    /*color: #fff !important;*/
  }
</style>